export default __webpack_public_path__ + "static/media/037-cheetah.02fab4ce.svg";